"use client";

import React from "react";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import { caseStudies } from "src/utils/mock/caseStudies";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import CommonContactSection from "src/components/Common/CommonContactSection";
import NavigationSection from "src/components/Common/NavigationSection";

import {
  BrandingHeroData,
  brandingStatsData,
  brandingSolutionsAndProcessData,
  brandingPortfolioData,
  brandingTechnologiesData,
  brandingAboutData,
  brandingFaqData,
} from "src/utils/mock/brandingData";
import { marketingServices } from "src/utils/mock/digitalMarketingData";

export default function BrandingComponent({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const brandingProjects = liveProjects.filter((project) => {
    const hasBrandingTech = project.technologies?.some((tech) => ["branding", "marketing", "seo", "design"].includes(tech.name?.toLowerCase()));
    const isActive = project.projectStatus?.toLowerCase() === "active";
    return hasBrandingTech && isActive;
  });

  const filteredData = {
    ...brandingPortfolioData,
    projects: {
      liveProjects: brandingProjects.length > 0 ? brandingProjects : liveProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;

  return (
    <div>
      <AppHero heroData={BrandingHeroData} />

      <TechStats stats={brandingStatsData} />

      {/* <NavigationSection data={marketingServices} leftHeading="Complete Digital" rightHeading=" Marketing Solutions" /> */}

      <WhyChooseUs data={brandingSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={brandingTechnologiesData} techIcons={techIcons} />
          <TechsSection mainTitle="About Our Branding Services" sections={brandingAboutData} />
        </div>
      </section>

      <FAQSection faqs={brandingFaqData} />

      <CommonContactSection />
    </div>
  );
}
